import { AxiosResponse } from 'axios';


export const parseFilenameFromContentDisposition = (disposition?: string): string | null => {
  if (!disposition) return null;
  const encoded = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(disposition);
  if (encoded) return decodeURIComponent(encoded[1].replace(/"/g, '').trim());
  const plain = /filename=("?)([^";]+)\1/i.exec(disposition);
  return plain ? plain[2].trim() : null;
};

export const downloadBlob = (data: Blob, filename: string) => {
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const downloadBlobResponse = (response: AxiosResponse<Blob>, fallbackFilename: string) => {
  const filename = parseFilenameFromContentDisposition(response.headers?.['content-disposition']) || fallbackFilename;
  downloadBlob(response.data, filename);
};
